import L from 'leaflet'
import i18n from '@/lang/index'
import Vue from 'vue'
const nameReg = /^[\u4e00-\u9fa5A-Za-z0-9-\_\——]+$/
export const timeOptions = [
  {
    label: 30 + i18n.tc('minutes') || '30分钟',
    num: 30,
    key: 'minutes',
    value: '1800'
  },
  {
    label: 1 + i18n.tc('hours') || '1小时',
    num: 1,
    key: 'hours',
    value: '3600'
  },
  {
    label: 2 + i18n.tc('hours') || '2小时',
    num: 2,
    key: 'hours',
    value: '7200'
  },
  {
    label: 24 + i18n.tc('hours') || '24小时',
    num: 24,
    key: 'hours',
    value: '86400'
  },
  {
    label: i18n.tc('permanent') || '永久',
    num: null,
    key: 'permanent',
    value: '0'
  }
]
// 火情状态
export const fireStates = [
  {
    label: i18n.tc('all') || '全部',
    key: 'all',
    value: ''
  },
  {
    label: i18n.tc('resolved') || '已解决',
    key: 'resolved',
    value: 0
  },
  {
    label: i18n.tc('fire') || '火灾',
    key: 'fire',
    value: 1
  },
  {
    label: i18n.tc('non_fire') || '非火灾',
    key: 'non_fire',
    value: 2
  },
  {
    label: i18n.tc('unprocessed') || '未处理',
    key: 'unprocessed',
    value: 3
  }
]
// 报警名称
export const alarmTypes = [
  {
    label: i18n.tc('all') || '全部',
    key: 'all',
    value: ''
  },
  {
    label: i18n.tc('thermal_fire_detection') || '热成像火点检测',
    key: 'thermal_fire_detection',
    value: '1'
  },
  {
    label: i18n.tc('visual_smokefire_detection') || '可见光烟火检测',
    key: 'visual_smokefire_detection',
    value: '2'
  }
]

export function judgeName(name) {
  if (!nameReg.test(name)) {
    Vue.prototype
      .$confirm(
        i18n.tc('names_can_only_contain_chinese_characters_numbers_english_and_') ||
          '名称仅允许输入汉字、数字、英文、“-”、“_” ',
        '',
        {
          confirmButtonText: i18n.tc('ok') || '确定',
          type: 'warning',
          showCancelButton: false,
          customClass: 'box-confirm'
        }
      )
      .then(() => {})
      .catch(() => {})
    return true
  }
  return false
}

export function formateDate(date) {
  if (date == null) {
    return null
  }
  const dt = new Date(date)
  const year = dt.getFullYear()
  let month = dt.getMonth() + 1
  if (month <= 9) {
    month = '0' + month
  }
  const day = dt.getDate() > 9 ? dt.getDate() : '0' + dt.getDate()
  const hour = dt.getHours() > 9 ? dt.getHours() : '0' + dt.getHours()
  const min = dt.getMinutes() > 9 ? dt.getMinutes() : '0' + dt.getMinutes()
  const second = dt.getSeconds() > 9 ? dt.getSeconds() : '0' + dt.getSeconds()

  const time = year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + second
  return time
}

export function isInNotifyList(list, curEventId) {
  let arr = list.find((item) => item.eventId === curEventId)
  let flag = true
  if (!arr) {
    flag = false
  }
  return flag
}

export function escapeHTMLString(str) {
  str = str.replace(/</g, '&lt;')
  str = str.replace(/>/g, '&gt;')
  return str
}
export function transMarkType(str) {
  let value = ''
  switch (str) {
    case 'markPoint':
      value = 1
      break
    case 'markLine':
      value = 2
      break
    case 'markArea':
      value = 3
      break
    case 'distance':
      value = 4
      break
    case 'area':
      value = 4
      break
    case 'angle':
      value = 6
      break
    case 'clear':
      value = 5
      break
    default:
      value = ''
      break
  }
  return value
}
export function latlngIsInArray(item, array) {
  let flag = false
  for (let i = 0; i < array.length; i++) {
    if (item.latitude === array[i].latitude && item.longitude === array[i].longitude) {
      flag = true
      break
    } else {
      flag = false
    }
  }
  return flag
}
export function isInArray(arr, info) {
  let flag = false
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][0] === info[0] && arr[i][1] === info[1]) {
      flag = true
      break
    } else {
      flag = false
    }
  }
  return flag
}
// 获取随机颜色
export function getRandomColor() {
  // 生成随机的红、绿、蓝三个 RGB 分量的值
  let r = Math.floor(Math.random() * 256)
  let g = Math.floor(Math.random() * 256)
  let b = Math.floor(Math.random() * 256)
  // 将 RGB 分量的值拼接成 CSS 颜色字符串
  let color = 'rgb(' + r + ', ' + g + ', ' + b + ')'
  return color
}

export function secondToStr(t) {
  // 日
  // let format_day = parseInt(t / (60 * 60 * 24))
  // 时
  let format_hour = parseInt((t % (60 * 60 * 24)) / (60 * 60))
  if (format_hour < 10) {
    format_hour = '0' + format_hour
  }
  // 分
  let format_minute = parseInt((t % 3600) / 60)
  if (format_minute < 10) {
    format_minute = '0' + format_minute
  }
  // 秒
  let format_second = t % 60
  if (format_second < 10) {
    format_second = '0' + (t % 60)
  }
  return (
    format_hour +
    i18n.tc('hours') +
    format_minute +
    i18n.tc('minutes') +
    format_second +
    i18n.tc('s')
  )
}

export function addCircleMarker(latlng, timeStr, color) {
  return new L.CircleMarker(latlng, {
    toolId: timeStr,
    color: color || '#3388FF',
    opacity: 1,
    weight: 1,
    fillColor: '#FFFFFF',
    fill: true,
    fillOpacity: 1,
    radius: 4,
    interactive: true
  })
}
// 获取角度
export function calcAngle(start, end, global) {
  // 获取map容器对象
  // 通过map 将起始点终止点经纬度坐标转容器坐标
  let max = Vue.prototype.global.configObj.maxZoom
  const pStart = Vue.prototype.$rgMap.project(start, max)
  const pEnd = Vue.prototype.$rgMap.project(end, max)
  // 计算容器坐标点位
  const diffX = pStart.x - pEnd.x
  const diffY = -(pStart.y - pEnd.y)
  let value = ''
  // 通过坐标计算角度 逆时针角度
  let angle = (360 * Math.atan2(diffY, diffX)) / (2 * Math.PI) + 90
  // 将逆时针角度转换成正角度
  angle = angle < 0 ? -angle : 360 - angle
  // angle是正北12点钟为基准的角度
  // 如果angle在0-90度，第一象限，= '东北 90-angle'
  // 如果angle在90-180度，第二象限，= '东南 angle-90'
  // 如果angle在180-270度，第三象限，= '西南 270-angle'
  // 如果angle在270-360度，第四象限，= '西北 angle-270'
  // 刚刚 = 90,180,270,360,是正东西南北向
  if (angle > 0 && angle < 90) {
    angle = 90 - angle
    value = i18n.tc('east_northeast') + ' ' + angle.toFixed(2) + '°'
  } else if (angle > 90 && angle < 180) {
    angle = angle - 90
    value = i18n.tc('east_southeast') + ' ' + angle.toFixed(2) + '°'
  } else if (angle > 180 && angle < 270) {
    angle = 270 - angle
    value = i18n.tc('west_southeast') + ' ' + angle.toFixed(2) + '°'
  } else if (angle > 270 && angle < 360) {
    angle = angle - 270
    value = i18n.tc('west_northwest') + ' ' + angle.toFixed(2) + '°'
  } else if (angle === 0 || angle === 360) {
    value = i18n.tc('true_north') + ' ' + '0°'
  } else if (angle === 90) {
    value = i18n.tc('true_east') + ' ' + '0°'
  } else if (angle === 180) {
    value = i18n.tc('true_south') + ' ' + '0°'
  } else if (angle === 270) {
    value = i18n.tc('true_west') + ' ' + '0°'
  }
  return value
}
// 单位米m转换为单位千米km
export function kmUnit(m) {
  let v
  if (typeof m === 'number' && !isNaN(m)) {
    if (m >= 1000) {
      v = (m / 1000).toFixed(2) + 'km'
    } else {
      v = parseInt(m) + 'm'
    }
  } else {
    v = '0m'
  }
  return v
}
// 获取与正北方向顺时针角度
export function calcAngleNorth(start, end, global) {
  // 获取map容器对象
  // 通过map 将起始点终止点经纬度坐标转容器坐标
  let max = Vue.prototype.global.configObj.maxZoom
  const pStart = Vue.prototype.$rgMap.project(start, max)
  const pEnd = Vue.prototype.$rgMap.project(end, max)
  // 计算容器坐标点位
  const diffX = pStart.x - pEnd.x
  const diffY = -(pStart.y - pEnd.y)
  // 通过坐标计算角度 逆时针角度
  let angle = (360 * Math.atan2(diffY, diffX)) / (2 * Math.PI) + 90
  // 将逆时针角度转换成正角度
  angle = angle < 0 ? -angle : 360 - angle
  // if (angle > 180) {
  //   angle = -(360 - angle)
  // }
  return angle
}
